import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDIUnA0SmzRc0gKpAS-X4Nqd5dr2lP_wBM",
  authDomain: "compandcodemessengerclone.firebaseapp.com",
  databaseURL: "https://compandcodemessengerclone.firebaseio.com",
  projectId: "compandcodemessengerclone",
  storageBucket: "compandcodemessengerclone.appspot.com",
  messagingSenderId: "544875878258",
  appId: "1:544875878258:web:1460b4c9782d96a47f2feb",
  measurementId: "G-GQVY3GTBGC"
});

const db = firebaseApp.firestore();

export default db;